@import "tailwindcss";

/*
 * Tailwind v4 + a small design-token layer compatible with shadcn's
 * "new-york" theme. Variables follow shadcn's naming so we can paste their
 * components later without further changes.
 */

@theme inline {
  --color-background: hsl(var(--bg));
  --color-foreground: hsl(var(--fg));
  --color-card: hsl(var(--card-bg));
  --color-card-foreground: hsl(var(--card-fg));
  --color-popover: hsl(var(--card-bg));
  --color-popover-foreground: hsl(var(--card-fg));
  --color-primary: hsl(var(--primary));
  --color-primary-foreground: hsl(var(--primary-fg));
  --color-secondary: hsl(var(--secondary));
  --color-secondary-foreground: hsl(var(--secondary-fg));
  --color-muted: hsl(var(--muted));
  --color-muted-foreground: hsl(var(--muted-fg));
  --color-accent: hsl(var(--accent));
  --color-accent-foreground: hsl(var(--accent-fg));
  --color-destructive: hsl(var(--destructive));
  --color-destructive-foreground: hsl(var(--destructive-fg));
  --color-border: hsl(var(--border));
  --color-input: hsl(var(--input));
  --color-ring: hsl(var(--ring));
  --radius: 0.5rem;
  --radius-sm: calc(var(--radius) - 4px);
  --radius-md: calc(var(--radius) - 2px);
  --radius-lg: var(--radius);
}

:root {
  --bg: 0 0% 100%;
  --fg: 240 10% 3.9%;
  --card-bg: 0 0% 100%;
  --card-fg: 240 10% 3.9%;
  --primary: 240 5.9% 10%;
  --primary-fg: 0 0% 98%;
  --secondary: 240 4.8% 95.9%;
  --secondary-fg: 240 5.9% 10%;
  --muted: 240 4.8% 95.9%;
  --muted-fg: 240 3.8% 46.1%;
  --accent: 240 4.8% 95.9%;
  --accent-fg: 240 5.9% 10%;
  --destructive: 0 84.2% 60.2%;
  --destructive-fg: 0 0% 98%;
  --border: 240 5.9% 90%;
  --input: 240 5.9% 90%;
  --ring: 240 5.9% 10%;
}

@media (prefers-color-scheme: dark) {
  :root {
    --bg: 240 10% 3.9%;
    --fg: 0 0% 98%;
    --card-bg: 240 10% 3.9%;
    --card-fg: 0 0% 98%;
    --primary: 0 0% 98%;
    --primary-fg: 240 5.9% 10%;
    --secondary: 240 3.7% 15.9%;
    --secondary-fg: 0 0% 98%;
    --muted: 240 3.7% 15.9%;
    --muted-fg: 240 5% 64.9%;
    --accent: 240 3.7% 15.9%;
    --accent-fg: 0 0% 98%;
    --destructive: 0 62.8% 30.6%;
    --destructive-fg: 0 0% 98%;
    --border: 240 3.7% 15.9%;
    --input: 240 3.7% 15.9%;
    --ring: 240 4.9% 83.9%;
  }
}

@layer base {
  * {
    @apply border-border;
  }
  body {
    @apply bg-background text-foreground;
    font-family:
      ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
    font-feature-settings: "rlig" 1, "calt" 1;
  }
}
